import {
  Hero,
  Products,
  About,
  Cta,
  Faq,
  QuickQuote,
  Testimonials,
} from "@components/sections";

export default function Home() {
  return (
    <>
      <Hero />
      <QuickQuote />
      <Products limit={6} />
      <About />
      <Testimonials />
      <Faq limit={4} />
      <Cta />
    </>
  );
}
